import { collection, serverTimestamp, doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";

const fglobales = {};

fglobales.addDoc = async (collectionText, data) => {
  const ref = doc(collection(db, collectionText));
  try {
    await setDoc(ref, {
      ...data,
      id: ref.id,
      timestamp: serverTimestamp(),
    });

    return {
      icon: "pi-check-circle",
      colorIcon: "green-500",
      headerMessage: `¡Excelente! Hemos recibido tu mensaje y estamos emocionados de ponernos en contacto contigo`,
      message:
        "Nos esforzaremos por responder lo antes posible. ¡Gracias por contactarnos!",
    };
  } catch (e) {
    console.log("Transacción fallida: ", e);
    return {
      icon: "pi-times-circle",
      colorIcon: "#FF0000",
      headerMessage: "Transacción fallida",
      message: "Error inesperado; póngase en contacto con soporte técnico",
    };
  }
};

export default fglobales;
